import { BaseEntity } from "./base-entity";

export class AspNetUsersAction extends BaseEntity{
    UserID: number = null;
    ActionID: number = null;
    Value: boolean = null;
    CompanyID: number = null;
    OrgJedID: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.UserID = input.UserID;
        this.ActionID = input.ActionID;
        this.Value = input.Value;
        this.CompanyID = input.CompanyID;
        this.OrgJedID = input.OrgJedID;

        return this;
    }
}